
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('g',[_c('path',{attrs:{"vector-effect":"non-scaling-stroke","d":"M1.204 2.941l4.019-1.354 4.275 1.497 3.804-1.497h.114a.356.356 0 01.357.357v7.025a4.14 4.14 0 00-1.425-.256c-1.09 0-2.088.427-2.85 1.111V4.509L5.223 3.012v8.48l2.878.997c-.028.17-.028.335-.028.499 0 .327.042.655.113.968l-2.964-1.04-3.804 1.475c-.043.021-.079.021-.114.021a.356.356 0 01-.357-.356V3.283c0-.164.115-.292.257-.342z"}}),_c('path',{attrs:{"vector-effect":"non-scaling-stroke","d":"M15.46 11.8l-2.45-2.45v1.4c-2.45.35-3.5 2.1-3.85 3.85.875-1.225 2.1-1.785 3.85-1.785v1.435l2.45-2.45z"}})])])
          )
        }
      }
    